import { actions, types } from './requests'
export const GETCONTRACT_TYPES = {
    ...types('GETCONTRACT'),
}
export const GETCONTRACT_ACTIONS = {
    ...actions('GETCONTRACT'),
}
